import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Page from 'components/Page/Dashboard';
import TournamentInfo from 'components/Play/Tournament/Edit/TournamentInfo';

const Step1 = ({ match }) => (
  <Page showNavigation={false}>
    <TournamentInfo edit={match.path.includes('edit')} />
  </Page>
);

Step1.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Step1);
